import { createContext } from "react"

/*
 * How a ⋯ menu (RowActions) hosts a confirmation reached from one of its items. The menu renders
 * each confirmation twice: in the menu, as its item alone, which closes the menu as any item does
 * and asks for the dialog; and beside the menu, as its dialog alone, which outlives the menu
 * closing. So the menu is gone while the Member answers, and Cancel or Esc returns to the page, not
 * to a menu left open behind the dialog. A confirmation outside a menu reads no host and draws its
 * trigger and dialog together.
 */
export type MenuConfirmationHost =
  | { part: "item"; ask: () => void }
  | { part: "dialog"; open: boolean; onOpenChange: (open: boolean) => void }

export const MenuConfirmationContext = createContext<MenuConfirmationHost | undefined>(undefined)
